import {
	SET_PROFILE_ICON_UPLOADING,
	SET_PROFILE_ICON_UPLOAD_PROGRESS,
	SET_PROFILE_ICON_URL,
	SET_PROFILE_ICON_ERROR,
	RESET_PROFILE_ICON_UPLOAD_STATE
} from '../../actions/profileIcon'

const initialState = {
	isUploading: false,
	uploadProgress: 0,
	iconUrl: null,
	error: null
}

const profileIconReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_PROFILE_ICON_UPLOADING:
			return {
				...state,
				isUploading: action.data
			}

		case SET_PROFILE_ICON_UPLOAD_PROGRESS:
			return {
				...state,
				uploadProgress: action.data
			}

		case SET_PROFILE_ICON_URL:
			return {
				...state,
				iconUrl: action.data,
				error: null
			}

		case SET_PROFILE_ICON_ERROR:
			return {
				...state,
				error: action.data,
				isUploading: false
			}

		case RESET_PROFILE_ICON_UPLOAD_STATE:
			return initialState

		default:
			return state
	}
}

export default profileIconReducer
